/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TahseelInboundRouteImport } from './routes/tahseel-inbound'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PaymentCallbackRouteImport } from './routes/payment-callback'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as AllSiteVisitsRouteImport } from './routes/all-site-visits'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as StudyRequestsIndexRouteImport } from './routes/study-requests/index'
import { Route as StudyReportsIndexRouteImport } from './routes/study-reports/index'
import { Route as SiteVisitsIndexRouteImport } from './routes/site-visits/index'
import { Route as PledgeStudiesIndexRouteImport } from './routes/pledge-studies/index'
import { Route as PermitsIndexRouteImport } from './routes/permits/index'
import { Route as NotificationsIndexRouteImport } from './routes/notifications/index'
import { Route as InspectionsIndexRouteImport } from './routes/inspections/index'
import { Route as CustomersIndexRouteImport } from './routes/customers/index'
import { Route as ConfigIndexRouteImport } from './routes/config/index'
import { Route as UsersNewRouteImport } from './routes/users/new'
import { Route as SurveyResponsesRouteImport } from './routes/survey/responses'
import { Route as SurveyTokenRouteImport } from './routes/survey/$token'
import { Route as StudyRequestsNewRouteImport } from './routes/study-requests/new'
import { Route as SmLoginRouteImport } from './routes/sm/login'
import { Route as SettingsProfileRouteImport } from './routes/settings/profile'
import { Route as PermitsNewRouteImport } from './routes/permits/new'
import { Route as PayTokenRouteImport } from './routes/pay/$token'
import { Route as CustomersNewRouteImport } from './routes/customers/new'
import { Route as ConfigUserTypesRouteImport } from './routes/config/user-types'
import { Route as ConfigPledgeStudyRouteImport } from './routes/config/pledge-study'
import { Route as UsersRolesIndexRouteImport } from './routes/users/roles/index'
import { Route as UsersUserIdIndexRouteImport } from './routes/users/$userId/index'
import { Route as StudyRequestsRequestIdIndexRouteImport } from './routes/study-requests/$requestId/index'
import { Route as PledgeStudiesPledgeStudyIdIndexRouteImport } from './routes/pledge-studies/$pledgeStudyId/index'
import { Route as PermitsPermitIdIndexRouteImport } from './routes/permits/$permitId/index'
import { Route as InspectionsInspectionIdIndexRouteImport } from './routes/inspections/$inspectionId/index'
import { Route as CustomersCustomerIdIndexRouteImport } from './routes/customers/$customerId/index'
import { Route as ConfigRequestTypesIndexRouteImport } from './routes/config/request-types/index'
import { Route as ConfigPermitTypesIndexRouteImport } from './routes/config/permit-types/index'
import { Route as ConfigPaymentGatewayIndexRouteImport } from './routes/config/payment-gateway/index'
import { Route as ConfigFeeComponentTypesIndexRouteImport } from './routes/config/fee-component-types/index'
import { Route as ConfigDocumentTypesIndexRouteImport } from './routes/config/document-types/index'
import { Route as ConfigApiClientsIndexRouteImport } from './routes/config/api-clients/index'
import { Route as UsersRolesNewRouteImport } from './routes/users/roles/new'
import { Route as UsersUserIdEditRouteImport } from './routes/users/$userId/edit'
import { Route as PledgeStudiesPledgeStudyIdEditRouteImport } from './routes/pledge-studies/$pledgeStudyId/edit'
import { Route as PermitsPermitIdPaymentRouteImport } from './routes/permits/$permitId/payment'
import { Route as InspectionsInspectionIdEditRouteImport } from './routes/inspections/$inspectionId/edit'
import { Route as CustomersCustomerIdEditRouteImport } from './routes/customers/$customerId/edit'
import { Route as CustomerSiteVisitApprovalTokenRouteImport } from './routes/customer/site-visit-approval.$token'
import { Route as UsersRolesRoleIdIndexRouteImport } from './routes/users/roles/$roleId/index'
import { Route as ConfigRequestTypesRequestTypeIdIndexRouteImport } from './routes/config/request-types/$requestTypeId/index'
import { Route as UsersRolesRoleIdEditRouteImport } from './routes/users/roles/$roleId/edit'
import { Route as ConfigRequestTypesRequestTypeIdRisksRouteImport } from './routes/config/request-types/$requestTypeId/risks'
import { Route as ConfigRequestTypesRequestTypeIdDocumentsRouteImport } from './routes/config/request-types/$requestTypeId/documents'

const TahseelInboundRoute = TahseelInboundRouteImport.update({
  id: '/tahseel-inbound',
  path: '/tahseel-inbound',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentCallbackRoute = PaymentCallbackRouteImport.update({
  id: '/payment-callback',
  path: '/payment-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AllSiteVisitsRoute = AllSiteVisitsRouteImport.update({
  id: '/all-site-visits',
  path: '/all-site-visits',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const StudyRequestsIndexRoute = StudyRequestsIndexRouteImport.update({
  id: '/study-requests/',
  path: '/study-requests/',
  getParentRoute: () => rootRouteImport,
} as any)
const StudyReportsIndexRoute = StudyReportsIndexRouteImport.update({
  id: '/study-reports/',
  path: '/study-reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteVisitsIndexRoute = SiteVisitsIndexRouteImport.update({
  id: '/site-visits/',
  path: '/site-visits/',
  getParentRoute: () => rootRouteImport,
} as any)
const PledgeStudiesIndexRoute = PledgeStudiesIndexRouteImport.update({
  id: '/pledge-studies/',
  path: '/pledge-studies/',
  getParentRoute: () => rootRouteImport,
} as any)
const PermitsIndexRoute = PermitsIndexRouteImport.update({
  id: '/permits/',
  path: '/permits/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsIndexRoute = NotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectionsIndexRoute = InspectionsIndexRouteImport.update({
  id: '/inspections/',
  path: '/inspections/',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersIndexRoute = CustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigIndexRoute = ConfigIndexRouteImport.update({
  id: '/config/',
  path: '/config/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersNewRoute = UsersNewRouteImport.update({
  id: '/users/new',
  path: '/users/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SurveyResponsesRoute = SurveyResponsesRouteImport.update({
  id: '/survey/responses',
  path: '/survey/responses',
  getParentRoute: () => rootRouteImport,
} as any)
const SurveyTokenRoute = SurveyTokenRouteImport.update({
  id: '/survey/$token',
  path: '/survey/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const StudyRequestsNewRoute = StudyRequestsNewRouteImport.update({
  id: '/study-requests/new',
  path: '/study-requests/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SmLoginRoute = SmLoginRouteImport.update({
  id: '/sm/login',
  path: '/sm/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PermitsNewRoute = PermitsNewRouteImport.update({
  id: '/permits/new',
  path: '/permits/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PayTokenRoute = PayTokenRouteImport.update({
  id: '/pay/$token',
  path: '/pay/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersNewRoute = CustomersNewRouteImport.update({
  id: '/customers/new',
  path: '/customers/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigUserTypesRoute = ConfigUserTypesRouteImport.update({
  id: '/config/user-types',
  path: '/config/user-types',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigPledgeStudyRoute = ConfigPledgeStudyRouteImport.update({
  id: '/config/pledge-study',
  path: '/config/pledge-study',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRolesIndexRoute = UsersRolesIndexRouteImport.update({
  id: '/users/roles/',
  path: '/users/roles/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdIndexRoute = UsersUserIdIndexRouteImport.update({
  id: '/users/$userId/',
  path: '/users/$userId/',
  getParentRoute: () => rootRouteImport,
} as any)
const StudyRequestsRequestIdIndexRoute =
  StudyRequestsRequestIdIndexRouteImport.update({
    id: '/study-requests/$requestId/',
    path: '/study-requests/$requestId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PledgeStudiesPledgeStudyIdIndexRoute =
  PledgeStudiesPledgeStudyIdIndexRouteImport.update({
    id: '/pledge-studies/$pledgeStudyId/',
    path: '/pledge-studies/$pledgeStudyId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PermitsPermitIdIndexRoute = PermitsPermitIdIndexRouteImport.update({
  id: '/permits/$permitId/',
  path: '/permits/$permitId/',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectionsInspectionIdIndexRoute =
  InspectionsInspectionIdIndexRouteImport.update({
    id: '/inspections/$inspectionId/',
    path: '/inspections/$inspectionId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CustomersCustomerIdIndexRoute =
  CustomersCustomerIdIndexRouteImport.update({
    id: '/customers/$customerId/',
    path: '/customers/$customerId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConfigRequestTypesIndexRoute = ConfigRequestTypesIndexRouteImport.update({
  id: '/config/request-types/',
  path: '/config/request-types/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigPermitTypesIndexRoute = ConfigPermitTypesIndexRouteImport.update({
  id: '/config/permit-types/',
  path: '/config/permit-types/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigPaymentGatewayIndexRoute =
  ConfigPaymentGatewayIndexRouteImport.update({
    id: '/config/payment-gateway/',
    path: '/config/payment-gateway/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConfigFeeComponentTypesIndexRoute =
  ConfigFeeComponentTypesIndexRouteImport.update({
    id: '/config/fee-component-types/',
    path: '/config/fee-component-types/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConfigDocumentTypesIndexRoute =
  ConfigDocumentTypesIndexRouteImport.update({
    id: '/config/document-types/',
    path: '/config/document-types/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConfigApiClientsIndexRoute = ConfigApiClientsIndexRouteImport.update({
  id: '/config/api-clients/',
  path: '/config/api-clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRolesNewRoute = UsersRolesNewRouteImport.update({
  id: '/users/roles/new',
  path: '/users/roles/new',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdEditRoute = UsersUserIdEditRouteImport.update({
  id: '/users/$userId/edit',
  path: '/users/$userId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const PledgeStudiesPledgeStudyIdEditRoute =
  PledgeStudiesPledgeStudyIdEditRouteImport.update({
    id: '/pledge-studies/$pledgeStudyId/edit',
    path: '/pledge-studies/$pledgeStudyId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const PermitsPermitIdPaymentRoute = PermitsPermitIdPaymentRouteImport.update({
  id: '/permits/$permitId/payment',
  path: '/permits/$permitId/payment',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectionsInspectionIdEditRoute =
  InspectionsInspectionIdEditRouteImport.update({
    id: '/inspections/$inspectionId/edit',
    path: '/inspections/$inspectionId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const CustomersCustomerIdEditRoute = CustomersCustomerIdEditRouteImport.update({
  id: '/customers/$customerId/edit',
  path: '/customers/$customerId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerSiteVisitApprovalTokenRoute =
  CustomerSiteVisitApprovalTokenRouteImport.update({
    id: '/customer/site-visit-approval/$token',
    path: '/customer/site-visit-approval/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const UsersRolesRoleIdIndexRoute = UsersRolesRoleIdIndexRouteImport.update({
  id: '/users/roles/$roleId/',
  path: '/users/roles/$roleId/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigRequestTypesRequestTypeIdIndexRoute =
  ConfigRequestTypesRequestTypeIdIndexRouteImport.update({
    id: '/config/request-types/$requestTypeId/',
    path: '/config/request-types/$requestTypeId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const UsersRolesRoleIdEditRoute = UsersRolesRoleIdEditRouteImport.update({
  id: '/users/roles/$roleId/edit',
  path: '/users/roles/$roleId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigRequestTypesRequestTypeIdRisksRoute =
  ConfigRequestTypesRequestTypeIdRisksRouteImport.update({
    id: '/config/request-types/$requestTypeId/risks',
    path: '/config/request-types/$requestTypeId/risks',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConfigRequestTypesRequestTypeIdDocumentsRoute =
  ConfigRequestTypesRequestTypeIdDocumentsRouteImport.update({
    id: '/config/request-types/$requestTypeId/documents',
    path: '/config/request-types/$requestTypeId/documents',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/all-site-visits': typeof AllSiteVisitsRoute
  '/change-password': typeof ChangePasswordRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/payment-callback': typeof PaymentCallbackRoute
  '/reset-password': typeof ResetPasswordRoute
  '/tahseel-inbound': typeof TahseelInboundRoute
  '/config/pledge-study': typeof ConfigPledgeStudyRoute
  '/config/user-types': typeof ConfigUserTypesRoute
  '/customers/new': typeof CustomersNewRoute
  '/pay/$token': typeof PayTokenRoute
  '/permits/new': typeof PermitsNewRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/sm/login': typeof SmLoginRoute
  '/study-requests/new': typeof StudyRequestsNewRoute
  '/survey/$token': typeof SurveyTokenRoute
  '/survey/responses': typeof SurveyResponsesRoute
  '/users/new': typeof UsersNewRoute
  '/config/': typeof ConfigIndexRoute
  '/customers/': typeof CustomersIndexRoute
  '/inspections/': typeof InspectionsIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/permits/': typeof PermitsIndexRoute
  '/pledge-studies/': typeof PledgeStudiesIndexRoute
  '/site-visits/': typeof SiteVisitsIndexRoute
  '/study-reports/': typeof StudyReportsIndexRoute
  '/study-requests/': typeof StudyRequestsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/customer/site-visit-approval/$token': typeof CustomerSiteVisitApprovalTokenRoute
  '/customers/$customerId/edit': typeof CustomersCustomerIdEditRoute
  '/inspections/$inspectionId/edit': typeof InspectionsInspectionIdEditRoute
  '/permits/$permitId/payment': typeof PermitsPermitIdPaymentRoute
  '/pledge-studies/$pledgeStudyId/edit': typeof PledgeStudiesPledgeStudyIdEditRoute
  '/users/$userId/edit': typeof UsersUserIdEditRoute
  '/users/roles/new': typeof UsersRolesNewRoute
  '/config/api-clients/': typeof ConfigApiClientsIndexRoute
  '/config/document-types/': typeof ConfigDocumentTypesIndexRoute
  '/config/fee-component-types/': typeof ConfigFeeComponentTypesIndexRoute
  '/config/payment-gateway/': typeof ConfigPaymentGatewayIndexRoute
  '/config/permit-types/': typeof ConfigPermitTypesIndexRoute
  '/config/request-types/': typeof ConfigRequestTypesIndexRoute
  '/customers/$customerId/': typeof CustomersCustomerIdIndexRoute
  '/inspections/$inspectionId/': typeof InspectionsInspectionIdIndexRoute
  '/permits/$permitId/': typeof PermitsPermitIdIndexRoute
  '/pledge-studies/$pledgeStudyId/': typeof PledgeStudiesPledgeStudyIdIndexRoute
  '/study-requests/$requestId/': typeof StudyRequestsRequestIdIndexRoute
  '/users/$userId/': typeof UsersUserIdIndexRoute
  '/users/roles/': typeof UsersRolesIndexRoute
  '/config/request-types/$requestTypeId/documents': typeof ConfigRequestTypesRequestTypeIdDocumentsRoute
  '/config/request-types/$requestTypeId/risks': typeof ConfigRequestTypesRequestTypeIdRisksRoute
  '/users/roles/$roleId/edit': typeof UsersRolesRoleIdEditRoute
  '/config/request-types/$requestTypeId/': typeof ConfigRequestTypesRequestTypeIdIndexRoute
  '/users/roles/$roleId/': typeof UsersRolesRoleIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/all-site-visits': typeof AllSiteVisitsRoute
  '/change-password': typeof ChangePasswordRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/payment-callback': typeof PaymentCallbackRoute
  '/reset-password': typeof ResetPasswordRoute
  '/tahseel-inbound': typeof TahseelInboundRoute
  '/config/pledge-study': typeof ConfigPledgeStudyRoute
  '/config/user-types': typeof ConfigUserTypesRoute
  '/customers/new': typeof CustomersNewRoute
  '/pay/$token': typeof PayTokenRoute
  '/permits/new': typeof PermitsNewRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/sm/login': typeof SmLoginRoute
  '/study-requests/new': typeof StudyRequestsNewRoute
  '/survey/$token': typeof SurveyTokenRoute
  '/survey/responses': typeof SurveyResponsesRoute
  '/users/new': typeof UsersNewRoute
  '/config': typeof ConfigIndexRoute
  '/customers': typeof CustomersIndexRoute
  '/inspections': typeof InspectionsIndexRoute
  '/notifications': typeof NotificationsIndexRoute
  '/permits': typeof PermitsIndexRoute
  '/pledge-studies': typeof PledgeStudiesIndexRoute
  '/site-visits': typeof SiteVisitsIndexRoute
  '/study-reports': typeof StudyReportsIndexRoute
  '/study-requests': typeof StudyRequestsIndexRoute
  '/users': typeof UsersIndexRoute
  '/customer/site-visit-approval/$token': typeof CustomerSiteVisitApprovalTokenRoute
  '/customers/$customerId/edit': typeof CustomersCustomerIdEditRoute
  '/inspections/$inspectionId/edit': typeof InspectionsInspectionIdEditRoute
  '/permits/$permitId/payment': typeof PermitsPermitIdPaymentRoute
  '/pledge-studies/$pledgeStudyId/edit': typeof PledgeStudiesPledgeStudyIdEditRoute
  '/users/$userId/edit': typeof UsersUserIdEditRoute
  '/users/roles/new': typeof UsersRolesNewRoute
  '/config/api-clients': typeof ConfigApiClientsIndexRoute
  '/config/document-types': typeof ConfigDocumentTypesIndexRoute
  '/config/fee-component-types': typeof ConfigFeeComponentTypesIndexRoute
  '/config/payment-gateway': typeof ConfigPaymentGatewayIndexRoute
  '/config/permit-types': typeof ConfigPermitTypesIndexRoute
  '/config/request-types': typeof ConfigRequestTypesIndexRoute
  '/customers/$customerId': typeof CustomersCustomerIdIndexRoute
  '/inspections/$inspectionId': typeof InspectionsInspectionIdIndexRoute
  '/permits/$permitId': typeof PermitsPermitIdIndexRoute
  '/pledge-studies/$pledgeStudyId': typeof PledgeStudiesPledgeStudyIdIndexRoute
  '/study-requests/$requestId': typeof StudyRequestsRequestIdIndexRoute
  '/users/$userId': typeof UsersUserIdIndexRoute
  '/users/roles': typeof UsersRolesIndexRoute
  '/config/request-types/$requestTypeId/documents': typeof ConfigRequestTypesRequestTypeIdDocumentsRoute
  '/config/request-types/$requestTypeId/risks': typeof ConfigRequestTypesRequestTypeIdRisksRoute
  '/users/roles/$roleId/edit': typeof UsersRolesRoleIdEditRoute
  '/config/request-types/$requestTypeId': typeof ConfigRequestTypesRequestTypeIdIndexRoute
  '/users/roles/$roleId': typeof UsersRolesRoleIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/all-site-visits': typeof AllSiteVisitsRoute
  '/change-password': typeof ChangePasswordRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/payment-callback': typeof PaymentCallbackRoute
  '/reset-password': typeof ResetPasswordRoute
  '/tahseel-inbound': typeof TahseelInboundRoute
  '/config/pledge-study': typeof ConfigPledgeStudyRoute
  '/config/user-types': typeof ConfigUserTypesRoute
  '/customers/new': typeof CustomersNewRoute
  '/pay/$token': typeof PayTokenRoute
  '/permits/new': typeof PermitsNewRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/sm/login': typeof SmLoginRoute
  '/study-requests/new': typeof StudyRequestsNewRoute
  '/survey/$token': typeof SurveyTokenRoute
  '/survey/responses': typeof SurveyResponsesRoute
  '/users/new': typeof UsersNewRoute
  '/config/': typeof ConfigIndexRoute
  '/customers/': typeof CustomersIndexRoute
  '/inspections/': typeof InspectionsIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/permits/': typeof PermitsIndexRoute
  '/pledge-studies/': typeof PledgeStudiesIndexRoute
  '/site-visits/': typeof SiteVisitsIndexRoute
  '/study-reports/': typeof StudyReportsIndexRoute
  '/study-requests/': typeof StudyRequestsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/customer/site-visit-approval/$token': typeof CustomerSiteVisitApprovalTokenRoute
  '/customers/$customerId/edit': typeof CustomersCustomerIdEditRoute
  '/inspections/$inspectionId/edit': typeof InspectionsInspectionIdEditRoute
  '/permits/$permitId/payment': typeof PermitsPermitIdPaymentRoute
  '/pledge-studies/$pledgeStudyId/edit': typeof PledgeStudiesPledgeStudyIdEditRoute
  '/users/$userId/edit': typeof UsersUserIdEditRoute
  '/users/roles/new': typeof UsersRolesNewRoute
  '/config/api-clients/': typeof ConfigApiClientsIndexRoute
  '/config/document-types/': typeof ConfigDocumentTypesIndexRoute
  '/config/fee-component-types/': typeof ConfigFeeComponentTypesIndexRoute
  '/config/payment-gateway/': typeof ConfigPaymentGatewayIndexRoute
  '/config/permit-types/': typeof ConfigPermitTypesIndexRoute
  '/config/request-types/': typeof ConfigRequestTypesIndexRoute
  '/customers/$customerId/': typeof CustomersCustomerIdIndexRoute
  '/inspections/$inspectionId/': typeof InspectionsInspectionIdIndexRoute
  '/permits/$permitId/': typeof PermitsPermitIdIndexRoute
  '/pledge-studies/$pledgeStudyId/': typeof PledgeStudiesPledgeStudyIdIndexRoute
  '/study-requests/$requestId/': typeof StudyRequestsRequestIdIndexRoute
  '/users/$userId/': typeof UsersUserIdIndexRoute
  '/users/roles/': typeof UsersRolesIndexRoute
  '/config/request-types/$requestTypeId/documents': typeof ConfigRequestTypesRequestTypeIdDocumentsRoute
  '/config/request-types/$requestTypeId/risks': typeof ConfigRequestTypesRequestTypeIdRisksRoute
  '/users/roles/$roleId/edit': typeof UsersRolesRoleIdEditRoute
  '/config/request-types/$requestTypeId/': typeof ConfigRequestTypesRequestTypeIdIndexRoute
  '/users/roles/$roleId/': typeof UsersRolesRoleIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/all-site-visits'
    | '/change-password'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/payment-callback'
    | '/reset-password'
    | '/tahseel-inbound'
    | '/config/pledge-study'
    | '/config/user-types'
    | '/customers/new'
    | '/pay/$token'
    | '/permits/new'
    | '/settings/profile'
    | '/sm/login'
    | '/study-requests/new'
    | '/survey/$token'
    | '/survey/responses'
    | '/users/new'
    | '/config/'
    | '/customers/'
    | '/inspections/'
    | '/notifications/'
    | '/permits/'
    | '/pledge-studies/'
    | '/site-visits/'
    | '/study-reports/'
    | '/study-requests/'
    | '/users/'
    | '/customer/site-visit-approval/$token'
    | '/customers/$customerId/edit'
    | '/inspections/$inspectionId/edit'
    | '/permits/$permitId/payment'
    | '/pledge-studies/$pledgeStudyId/edit'
    | '/users/$userId/edit'
    | '/users/roles/new'
    | '/config/api-clients/'
    | '/config/document-types/'
    | '/config/fee-component-types/'
    | '/config/payment-gateway/'
    | '/config/permit-types/'
    | '/config/request-types/'
    | '/customers/$customerId/'
    | '/inspections/$inspectionId/'
    | '/permits/$permitId/'
    | '/pledge-studies/$pledgeStudyId/'
    | '/study-requests/$requestId/'
    | '/users/$userId/'
    | '/users/roles/'
    | '/config/request-types/$requestTypeId/documents'
    | '/config/request-types/$requestTypeId/risks'
    | '/users/roles/$roleId/edit'
    | '/config/request-types/$requestTypeId/'
    | '/users/roles/$roleId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/all-site-visits'
    | '/change-password'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/payment-callback'
    | '/reset-password'
    | '/tahseel-inbound'
    | '/config/pledge-study'
    | '/config/user-types'
    | '/customers/new'
    | '/pay/$token'
    | '/permits/new'
    | '/settings/profile'
    | '/sm/login'
    | '/study-requests/new'
    | '/survey/$token'
    | '/survey/responses'
    | '/users/new'
    | '/config'
    | '/customers'
    | '/inspections'
    | '/notifications'
    | '/permits'
    | '/pledge-studies'
    | '/site-visits'
    | '/study-reports'
    | '/study-requests'
    | '/users'
    | '/customer/site-visit-approval/$token'
    | '/customers/$customerId/edit'
    | '/inspections/$inspectionId/edit'
    | '/permits/$permitId/payment'
    | '/pledge-studies/$pledgeStudyId/edit'
    | '/users/$userId/edit'
    | '/users/roles/new'
    | '/config/api-clients'
    | '/config/document-types'
    | '/config/fee-component-types'
    | '/config/payment-gateway'
    | '/config/permit-types'
    | '/config/request-types'
    | '/customers/$customerId'
    | '/inspections/$inspectionId'
    | '/permits/$permitId'
    | '/pledge-studies/$pledgeStudyId'
    | '/study-requests/$requestId'
    | '/users/$userId'
    | '/users/roles'
    | '/config/request-types/$requestTypeId/documents'
    | '/config/request-types/$requestTypeId/risks'
    | '/users/roles/$roleId/edit'
    | '/config/request-types/$requestTypeId'
    | '/users/roles/$roleId'
  id:
    | '__root__'
    | '/'
    | '/all-site-visits'
    | '/change-password'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/payment-callback'
    | '/reset-password'
    | '/tahseel-inbound'
    | '/config/pledge-study'
    | '/config/user-types'
    | '/customers/new'
    | '/pay/$token'
    | '/permits/new'
    | '/settings/profile'
    | '/sm/login'
    | '/study-requests/new'
    | '/survey/$token'
    | '/survey/responses'
    | '/users/new'
    | '/config/'
    | '/customers/'
    | '/inspections/'
    | '/notifications/'
    | '/permits/'
    | '/pledge-studies/'
    | '/site-visits/'
    | '/study-reports/'
    | '/study-requests/'
    | '/users/'
    | '/customer/site-visit-approval/$token'
    | '/customers/$customerId/edit'
    | '/inspections/$inspectionId/edit'
    | '/permits/$permitId/payment'
    | '/pledge-studies/$pledgeStudyId/edit'
    | '/users/$userId/edit'
    | '/users/roles/new'
    | '/config/api-clients/'
    | '/config/document-types/'
    | '/config/fee-component-types/'
    | '/config/payment-gateway/'
    | '/config/permit-types/'
    | '/config/request-types/'
    | '/customers/$customerId/'
    | '/inspections/$inspectionId/'
    | '/permits/$permitId/'
    | '/pledge-studies/$pledgeStudyId/'
    | '/study-requests/$requestId/'
    | '/users/$userId/'
    | '/users/roles/'
    | '/config/request-types/$requestTypeId/documents'
    | '/config/request-types/$requestTypeId/risks'
    | '/users/roles/$roleId/edit'
    | '/config/request-types/$requestTypeId/'
    | '/users/roles/$roleId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AllSiteVisitsRoute: typeof AllSiteVisitsRoute
  ChangePasswordRoute: typeof ChangePasswordRoute
  DashboardRoute: typeof DashboardRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PaymentCallbackRoute: typeof PaymentCallbackRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TahseelInboundRoute: typeof TahseelInboundRoute
  ConfigPledgeStudyRoute: typeof ConfigPledgeStudyRoute
  ConfigUserTypesRoute: typeof ConfigUserTypesRoute
  CustomersNewRoute: typeof CustomersNewRoute
  PayTokenRoute: typeof PayTokenRoute
  PermitsNewRoute: typeof PermitsNewRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SmLoginRoute: typeof SmLoginRoute
  StudyRequestsNewRoute: typeof StudyRequestsNewRoute
  SurveyTokenRoute: typeof SurveyTokenRoute
  SurveyResponsesRoute: typeof SurveyResponsesRoute
  UsersNewRoute: typeof UsersNewRoute
  ConfigIndexRoute: typeof ConfigIndexRoute
  CustomersIndexRoute: typeof CustomersIndexRoute
  InspectionsIndexRoute: typeof InspectionsIndexRoute
  NotificationsIndexRoute: typeof NotificationsIndexRoute
  PermitsIndexRoute: typeof PermitsIndexRoute
  PledgeStudiesIndexRoute: typeof PledgeStudiesIndexRoute
  SiteVisitsIndexRoute: typeof SiteVisitsIndexRoute
  StudyReportsIndexRoute: typeof StudyReportsIndexRoute
  StudyRequestsIndexRoute: typeof StudyRequestsIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  CustomerSiteVisitApprovalTokenRoute: typeof CustomerSiteVisitApprovalTokenRoute
  CustomersCustomerIdEditRoute: typeof CustomersCustomerIdEditRoute
  InspectionsInspectionIdEditRoute: typeof InspectionsInspectionIdEditRoute
  PermitsPermitIdPaymentRoute: typeof PermitsPermitIdPaymentRoute
  PledgeStudiesPledgeStudyIdEditRoute: typeof PledgeStudiesPledgeStudyIdEditRoute
  UsersUserIdEditRoute: typeof UsersUserIdEditRoute
  UsersRolesNewRoute: typeof UsersRolesNewRoute
  ConfigApiClientsIndexRoute: typeof ConfigApiClientsIndexRoute
  ConfigDocumentTypesIndexRoute: typeof ConfigDocumentTypesIndexRoute
  ConfigFeeComponentTypesIndexRoute: typeof ConfigFeeComponentTypesIndexRoute
  ConfigPaymentGatewayIndexRoute: typeof ConfigPaymentGatewayIndexRoute
  ConfigPermitTypesIndexRoute: typeof ConfigPermitTypesIndexRoute
  ConfigRequestTypesIndexRoute: typeof ConfigRequestTypesIndexRoute
  CustomersCustomerIdIndexRoute: typeof CustomersCustomerIdIndexRoute
  InspectionsInspectionIdIndexRoute: typeof InspectionsInspectionIdIndexRoute
  PermitsPermitIdIndexRoute: typeof PermitsPermitIdIndexRoute
  PledgeStudiesPledgeStudyIdIndexRoute: typeof PledgeStudiesPledgeStudyIdIndexRoute
  StudyRequestsRequestIdIndexRoute: typeof StudyRequestsRequestIdIndexRoute
  UsersUserIdIndexRoute: typeof UsersUserIdIndexRoute
  UsersRolesIndexRoute: typeof UsersRolesIndexRoute
  ConfigRequestTypesRequestTypeIdDocumentsRoute: typeof ConfigRequestTypesRequestTypeIdDocumentsRoute
  ConfigRequestTypesRequestTypeIdRisksRoute: typeof ConfigRequestTypesRequestTypeIdRisksRoute
  UsersRolesRoleIdEditRoute: typeof UsersRolesRoleIdEditRoute
  ConfigRequestTypesRequestTypeIdIndexRoute: typeof ConfigRequestTypesRequestTypeIdIndexRoute
  UsersRolesRoleIdIndexRoute: typeof UsersRolesRoleIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/tahseel-inbound': {
      id: '/tahseel-inbound'
      path: '/tahseel-inbound'
      fullPath: '/tahseel-inbound'
      preLoaderRoute: typeof TahseelInboundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-callback': {
      id: '/payment-callback'
      path: '/payment-callback'
      fullPath: '/payment-callback'
      preLoaderRoute: typeof PaymentCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/all-site-visits': {
      id: '/all-site-visits'
      path: '/all-site-visits'
      fullPath: '/all-site-visits'
      preLoaderRoute: typeof AllSiteVisitsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-requests/': {
      id: '/study-requests/'
      path: '/study-requests'
      fullPath: '/study-requests/'
      preLoaderRoute: typeof StudyRequestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-reports/': {
      id: '/study-reports/'
      path: '/study-reports'
      fullPath: '/study-reports/'
      preLoaderRoute: typeof StudyReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/site-visits/': {
      id: '/site-visits/'
      path: '/site-visits'
      fullPath: '/site-visits/'
      preLoaderRoute: typeof SiteVisitsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pledge-studies/': {
      id: '/pledge-studies/'
      path: '/pledge-studies'
      fullPath: '/pledge-studies/'
      preLoaderRoute: typeof PledgeStudiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/permits/': {
      id: '/permits/'
      path: '/permits'
      fullPath: '/permits/'
      preLoaderRoute: typeof PermitsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/': {
      id: '/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof NotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspections/': {
      id: '/inspections/'
      path: '/inspections'
      fullPath: '/inspections/'
      preLoaderRoute: typeof InspectionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/': {
      id: '/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof CustomersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/': {
      id: '/config/'
      path: '/config'
      fullPath: '/config/'
      preLoaderRoute: typeof ConfigIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/new': {
      id: '/users/new'
      path: '/users/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof UsersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/survey/responses': {
      id: '/survey/responses'
      path: '/survey/responses'
      fullPath: '/survey/responses'
      preLoaderRoute: typeof SurveyResponsesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/survey/$token': {
      id: '/survey/$token'
      path: '/survey/$token'
      fullPath: '/survey/$token'
      preLoaderRoute: typeof SurveyTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-requests/new': {
      id: '/study-requests/new'
      path: '/study-requests/new'
      fullPath: '/study-requests/new'
      preLoaderRoute: typeof StudyRequestsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sm/login': {
      id: '/sm/login'
      path: '/sm/login'
      fullPath: '/sm/login'
      preLoaderRoute: typeof SmLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/permits/new': {
      id: '/permits/new'
      path: '/permits/new'
      fullPath: '/permits/new'
      preLoaderRoute: typeof PermitsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pay/$token': {
      id: '/pay/$token'
      path: '/pay/$token'
      fullPath: '/pay/$token'
      preLoaderRoute: typeof PayTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/new': {
      id: '/customers/new'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof CustomersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/user-types': {
      id: '/config/user-types'
      path: '/config/user-types'
      fullPath: '/config/user-types'
      preLoaderRoute: typeof ConfigUserTypesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/pledge-study': {
      id: '/config/pledge-study'
      path: '/config/pledge-study'
      fullPath: '/config/pledge-study'
      preLoaderRoute: typeof ConfigPledgeStudyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/roles/': {
      id: '/users/roles/'
      path: '/users/roles'
      fullPath: '/users/roles/'
      preLoaderRoute: typeof UsersRolesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userId/': {
      id: '/users/$userId/'
      path: '/users/$userId'
      fullPath: '/users/$userId/'
      preLoaderRoute: typeof UsersUserIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-requests/$requestId/': {
      id: '/study-requests/$requestId/'
      path: '/study-requests/$requestId'
      fullPath: '/study-requests/$requestId/'
      preLoaderRoute: typeof StudyRequestsRequestIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pledge-studies/$pledgeStudyId/': {
      id: '/pledge-studies/$pledgeStudyId/'
      path: '/pledge-studies/$pledgeStudyId'
      fullPath: '/pledge-studies/$pledgeStudyId/'
      preLoaderRoute: typeof PledgeStudiesPledgeStudyIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/permits/$permitId/': {
      id: '/permits/$permitId/'
      path: '/permits/$permitId'
      fullPath: '/permits/$permitId/'
      preLoaderRoute: typeof PermitsPermitIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspections/$inspectionId/': {
      id: '/inspections/$inspectionId/'
      path: '/inspections/$inspectionId'
      fullPath: '/inspections/$inspectionId/'
      preLoaderRoute: typeof InspectionsInspectionIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/$customerId/': {
      id: '/customers/$customerId/'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId/'
      preLoaderRoute: typeof CustomersCustomerIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/request-types/': {
      id: '/config/request-types/'
      path: '/config/request-types'
      fullPath: '/config/request-types/'
      preLoaderRoute: typeof ConfigRequestTypesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/permit-types/': {
      id: '/config/permit-types/'
      path: '/config/permit-types'
      fullPath: '/config/permit-types/'
      preLoaderRoute: typeof ConfigPermitTypesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/payment-gateway/': {
      id: '/config/payment-gateway/'
      path: '/config/payment-gateway'
      fullPath: '/config/payment-gateway/'
      preLoaderRoute: typeof ConfigPaymentGatewayIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/fee-component-types/': {
      id: '/config/fee-component-types/'
      path: '/config/fee-component-types'
      fullPath: '/config/fee-component-types/'
      preLoaderRoute: typeof ConfigFeeComponentTypesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/document-types/': {
      id: '/config/document-types/'
      path: '/config/document-types'
      fullPath: '/config/document-types/'
      preLoaderRoute: typeof ConfigDocumentTypesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/api-clients/': {
      id: '/config/api-clients/'
      path: '/config/api-clients'
      fullPath: '/config/api-clients/'
      preLoaderRoute: typeof ConfigApiClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/roles/new': {
      id: '/users/roles/new'
      path: '/users/roles/new'
      fullPath: '/users/roles/new'
      preLoaderRoute: typeof UsersRolesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userId/edit': {
      id: '/users/$userId/edit'
      path: '/users/$userId/edit'
      fullPath: '/users/$userId/edit'
      preLoaderRoute: typeof UsersUserIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pledge-studies/$pledgeStudyId/edit': {
      id: '/pledge-studies/$pledgeStudyId/edit'
      path: '/pledge-studies/$pledgeStudyId/edit'
      fullPath: '/pledge-studies/$pledgeStudyId/edit'
      preLoaderRoute: typeof PledgeStudiesPledgeStudyIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/permits/$permitId/payment': {
      id: '/permits/$permitId/payment'
      path: '/permits/$permitId/payment'
      fullPath: '/permits/$permitId/payment'
      preLoaderRoute: typeof PermitsPermitIdPaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspections/$inspectionId/edit': {
      id: '/inspections/$inspectionId/edit'
      path: '/inspections/$inspectionId/edit'
      fullPath: '/inspections/$inspectionId/edit'
      preLoaderRoute: typeof InspectionsInspectionIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/$customerId/edit': {
      id: '/customers/$customerId/edit'
      path: '/customers/$customerId/edit'
      fullPath: '/customers/$customerId/edit'
      preLoaderRoute: typeof CustomersCustomerIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer/site-visit-approval/$token': {
      id: '/customer/site-visit-approval/$token'
      path: '/customer/site-visit-approval/$token'
      fullPath: '/customer/site-visit-approval/$token'
      preLoaderRoute: typeof CustomerSiteVisitApprovalTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/roles/$roleId/': {
      id: '/users/roles/$roleId/'
      path: '/users/roles/$roleId'
      fullPath: '/users/roles/$roleId/'
      preLoaderRoute: typeof UsersRolesRoleIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/request-types/$requestTypeId/': {
      id: '/config/request-types/$requestTypeId/'
      path: '/config/request-types/$requestTypeId'
      fullPath: '/config/request-types/$requestTypeId/'
      preLoaderRoute: typeof ConfigRequestTypesRequestTypeIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/roles/$roleId/edit': {
      id: '/users/roles/$roleId/edit'
      path: '/users/roles/$roleId/edit'
      fullPath: '/users/roles/$roleId/edit'
      preLoaderRoute: typeof UsersRolesRoleIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/request-types/$requestTypeId/risks': {
      id: '/config/request-types/$requestTypeId/risks'
      path: '/config/request-types/$requestTypeId/risks'
      fullPath: '/config/request-types/$requestTypeId/risks'
      preLoaderRoute: typeof ConfigRequestTypesRequestTypeIdRisksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config/request-types/$requestTypeId/documents': {
      id: '/config/request-types/$requestTypeId/documents'
      path: '/config/request-types/$requestTypeId/documents'
      fullPath: '/config/request-types/$requestTypeId/documents'
      preLoaderRoute: typeof ConfigRequestTypesRequestTypeIdDocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AllSiteVisitsRoute: AllSiteVisitsRoute,
  ChangePasswordRoute: ChangePasswordRoute,
  DashboardRoute: DashboardRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PaymentCallbackRoute: PaymentCallbackRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TahseelInboundRoute: TahseelInboundRoute,
  ConfigPledgeStudyRoute: ConfigPledgeStudyRoute,
  ConfigUserTypesRoute: ConfigUserTypesRoute,
  CustomersNewRoute: CustomersNewRoute,
  PayTokenRoute: PayTokenRoute,
  PermitsNewRoute: PermitsNewRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SmLoginRoute: SmLoginRoute,
  StudyRequestsNewRoute: StudyRequestsNewRoute,
  SurveyTokenRoute: SurveyTokenRoute,
  SurveyResponsesRoute: SurveyResponsesRoute,
  UsersNewRoute: UsersNewRoute,
  ConfigIndexRoute: ConfigIndexRoute,
  CustomersIndexRoute: CustomersIndexRoute,
  InspectionsIndexRoute: InspectionsIndexRoute,
  NotificationsIndexRoute: NotificationsIndexRoute,
  PermitsIndexRoute: PermitsIndexRoute,
  PledgeStudiesIndexRoute: PledgeStudiesIndexRoute,
  SiteVisitsIndexRoute: SiteVisitsIndexRoute,
  StudyReportsIndexRoute: StudyReportsIndexRoute,
  StudyRequestsIndexRoute: StudyRequestsIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  CustomerSiteVisitApprovalTokenRoute: CustomerSiteVisitApprovalTokenRoute,
  CustomersCustomerIdEditRoute: CustomersCustomerIdEditRoute,
  InspectionsInspectionIdEditRoute: InspectionsInspectionIdEditRoute,
  PermitsPermitIdPaymentRoute: PermitsPermitIdPaymentRoute,
  PledgeStudiesPledgeStudyIdEditRoute: PledgeStudiesPledgeStudyIdEditRoute,
  UsersUserIdEditRoute: UsersUserIdEditRoute,
  UsersRolesNewRoute: UsersRolesNewRoute,
  ConfigApiClientsIndexRoute: ConfigApiClientsIndexRoute,
  ConfigDocumentTypesIndexRoute: ConfigDocumentTypesIndexRoute,
  ConfigFeeComponentTypesIndexRoute: ConfigFeeComponentTypesIndexRoute,
  ConfigPaymentGatewayIndexRoute: ConfigPaymentGatewayIndexRoute,
  ConfigPermitTypesIndexRoute: ConfigPermitTypesIndexRoute,
  ConfigRequestTypesIndexRoute: ConfigRequestTypesIndexRoute,
  CustomersCustomerIdIndexRoute: CustomersCustomerIdIndexRoute,
  InspectionsInspectionIdIndexRoute: InspectionsInspectionIdIndexRoute,
  PermitsPermitIdIndexRoute: PermitsPermitIdIndexRoute,
  PledgeStudiesPledgeStudyIdIndexRoute: PledgeStudiesPledgeStudyIdIndexRoute,
  StudyRequestsRequestIdIndexRoute: StudyRequestsRequestIdIndexRoute,
  UsersUserIdIndexRoute: UsersUserIdIndexRoute,
  UsersRolesIndexRoute: UsersRolesIndexRoute,
  ConfigRequestTypesRequestTypeIdDocumentsRoute:
    ConfigRequestTypesRequestTypeIdDocumentsRoute,
  ConfigRequestTypesRequestTypeIdRisksRoute:
    ConfigRequestTypesRequestTypeIdRisksRoute,
  UsersRolesRoleIdEditRoute: UsersRolesRoleIdEditRoute,
  ConfigRequestTypesRequestTypeIdIndexRoute:
    ConfigRequestTypesRequestTypeIdIndexRoute,
  UsersRolesRoleIdIndexRoute: UsersRolesRoleIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
